import { render } from "./ElectroOptic.vue?vue&type=template&id=cbe94c4c&scoped=true"
import script from "./ElectroOptic.vue?vue&type=script&lang=js"
export * from "./ElectroOptic.vue?vue&type=script&lang=js"

import "./ElectroOptic.vue?vue&type=style&index=0&id=cbe94c4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe94c4c"]])

export default __exports__